import { i18n } from '@/i18n/i18n'
import Configuration from './Configuration.js'

export default {
  /* the dashboard configuration api */

  getApplicationDashboard (applicationId) {
    const { dashboard, dashboardId } = Configuration.getApplication(applicationId)
    const privilegeId = `/${applicationId}/dashboard/${dashboardId}`
    if (
      dashboardId &&
      dashboard[dashboardId] &&
      Configuration.auth.userHasPrivilege(privilegeId)
    ) {
      return dashboard[dashboardId]
    }
    return null
  },

  getWorkspaceDashboard (applicationId, workspaceId, dashboardId) {
    const workspace = Configuration.auth.findWorkspace(applicationId, workspaceId)

    if (workspace) {
      const { dashboard } = Configuration.getApplication(applicationId)

      const privilegeId = `/${applicationId}/workspace/${workspaceId}/dashboard/${dashboardId}`
      if (
        dashboardId &&
        dashboard[dashboardId] &&
        Configuration.auth.userHasPrivilege(privilegeId)
      ) {
        return dashboard[dashboardId]
      }
    }

    return null
  },

  getTrackerDashboard (applicationId, workspaceId, trackerTypeId) {
    const workspace = Configuration.auth.findWorkspace(applicationId, workspaceId)
    const tracker = Configuration.auth.getTrackerTypes(applicationId, workspaceId)[trackerTypeId]

    if (workspace && tracker) {
      const { dashboard } = tracker

      if (dashboard) {
        return dashboard
      }
    }

    return null
  },

  getAppDashboardContext (applicationId) {
    const { id, baseURL, dashboardId, query } = Configuration.getApplication(applicationId)
    const privilegeId = `/${applicationId}/dashboard/${dashboardId}`
    const dashboard = this.getApplicationDashboard(applicationId)

    if (
      dashboard &&
      Configuration.auth.userHasPrivilege(privilegeId)
    ) {
      // Inject filter on current context: applicationId
      const filterArray = [
        { field: 'applicationId', operator: 'EQUALS', value: applicationId }
      ]

      return { applicationId: id, baseURL, dashboard, query, filterArray, privilegeId }
    }
    return {}
  },

  getWorkspaceDashboardContext (applicationId, workspaceId, dashboardId) {
    const workspace = Configuration.auth.findWorkspace(applicationId, workspaceId)
    const workspaceName = workspace.name ? i18n.t(workspace.name) : workspaceId
    const { id, baseURL, query } = Configuration.getApplication(applicationId)
    const dashboard = this.getWorkspaceDashboard(applicationId, workspaceId, dashboardId)

    const privilegeId = `/${applicationId}/workspace/${workspaceId}/dashboard/${dashboardId}`
    if (
      dashboard &&
      Configuration.auth.userHasPrivilege(privilegeId)
    ) {
      // Inject filter on current context: applicationId + workspaceId
      const filterArray = [
        { field: 'workspaceId', operator: 'EQUALS', value: workspaceId },
        { field: 'applicationId', operator: 'EQUALS', value: applicationId }
      ]

      return {
        applicationId: id,
        baseURL,
        dashboard,
        query,
        workspace: true,
        workspaceName,
        filterArray,
        privilegeId
      }
    }
    return {}
  },

  getTrackerDashboardContext (applicationId, workspaceId, trackerTypeId, trackerId) {
    const workspace = Configuration.auth.findWorkspace(applicationId, workspaceId)
    const workspaceName = workspace.name ? i18n.t(workspace.name) : workspaceId
    const tracker = Configuration.auth.getTrackerTypes(applicationId, workspaceId)[trackerTypeId]
    const trackerName = tracker.name ? i18n.t(tracker.name) : trackerTypeId
    const { id, baseURL, query } = Configuration.getApplication(applicationId)
    const dashboard = this.getTrackerDashboard(applicationId, workspaceId, trackerTypeId)
    const privilegeId = `/${applicationId}/workspace/${workspaceId}/tracker/${trackerTypeId}/dashboard`

    if (dashboard) {
      const filterArray = [
        { field: 'applicationId', operator: 'EQUALS', value: applicationId },
        { field: 'workspaceId', operator: 'EQUALS', value: workspaceId },
        { field: 'trackerId', operator: 'EQUALS', value: trackerId }
      ]

      return {
        applicationId: id,
        baseURL,
        dashboard,
        query,
        tracker: true,
        trackerName,
        workspaceName,
        filterArray,
        privilegeId
      }
    }
    return {}
  }
}
